import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {PricingApiService} from './pricing-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    PricingApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkPricingModule { }
